export default {
  total(amount, tax) {
    let total = 0
    if (tax.rate !== undefined) {
      tax.rate = tax.rate.toString().replace(',', '.')
      if (tax.rate > 1) {
        tax.rate = tax.rate / 100
      }
      total = amount * parseFloat(tax.rate)
    }
    return total
  },
  totalTaxes(amount, taxes) {
    let total = 0
    for(let tax in taxes) {
      tax = taxes[tax]
      if (tax.rate !== undefined) {
        tax.rate = tax.rate.toString().replace(',', '.')
        if (tax.rate > 1) {
          tax.rate = tax.rate / 100
        }
        total += (amount * parseFloat(tax.rate))
      }
    }
    return total
  },
  display(taxes, showRate, join, abbr) {
    if (abbr === undefined) {
      abbr = true
    }
    if (showRate === undefined) {
      showRate = false
    }
    if (join === undefined) {
      join = ','
    }
    let labels = []
    for(let taxIndex in taxes) {
      let tax = taxes[taxIndex]
      if(tax.label !== undefined){
        let label = tax.label
        if (abbr && label.length > 3) {
          label = label.substring(0, 3)
        }
        if (showRate) {
          let rate = tax.rate.toString().replace(',', '.')
          if (rate < 1) {
            rate = rate * 100
          }
          label += ' (' + rate + '%)'
        }
        labels.push(label)
      }
    }
    return labels.join(join)
  }
}
